import { render } from "./AliaseEmail.vue?vue&type=template&id=0f0d95bc&ts=true"
import script from "./AliaseEmail.vue?vue&type=script&lang=ts"
export * from "./AliaseEmail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__